import SelectInput from "@builder/components/general/ConditionSelectInput";
import "./style.scss";
import { getPopups } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { useEffect, useState } from "react";
import { ActionType } from "@common/build/types";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useTranslation } from "react-i18next";

const Popup = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const dispatch = useAppDispatch();
    const popups = useAppSelector(getPopups);
    const [selectedPopup, setSelectedPopup] = useState<string>(actionStep?.action?.target || "");

    const popupNames = popups.map(popup => popup.name);

    const { t } = useTranslation();

    useEffect(() => {
        if (selectedPopup) {
            const action = { type: ActionType.OPEN_MODAL, target: selectedPopup };
            const updatedStep = {
                ...actionStep,
                title: `${t("popup.actionBuilder.Open popup")}: ${selectedPopup}`,
                noTranslate: true
            };
            updatedStep.action = { ...action };
            if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
                dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
            }
        }
    }, [selectedPopup, actionStep, dispatch, id, t]);

    return (
        <div className="action-popup-wrapper">
            <SelectInput
                title="Popup"
                layout="column"
                value={selectedPopup}
                callback={setSelectedPopup}
                options={popupNames}
                placeholder="Select popup"
            />
        </div>
    );
};

export default Popup;
